// What a card shows while its data loads: grey shapes where the content will
// land, the size of that content, so that nothing jumps when it arrives (as
// the task panel's TaskPanelSkeletons). A line of text, or a list of rows
// under a card's frame. `aria-busy` tells assistive technologies to wait.

const GHOST = 'block rounded bg-gray-200 animate-pulse';

/** A line of text to come: `className` gives its width (and its height). */
export const SkeletonLine = ({ className = 'w-32' }) => (
  <span aria-hidden="true" className={`h-3.5 ${GHOST} ${className}`} />
);

/**
 * Rows of a card or a list: a title line over a lighter line, each row the
 * height of a row of text (py-3 px-4), a line between them.
 */
export const SkeletonRows = ({ rows = 3, className = '' }) => (
  <div aria-busy="true" className={`divide-y divide-gray-100 ${className}`}>
    {Array.from({ length: rows }, (_, index) => (
      <div key={index} className="flex flex-col gap-2 px-4 py-3">
        <SkeletonLine className={index % 2 ? 'w-2/5' : 'w-1/2'} />
        <SkeletonLine className={`h-3 ${index % 2 ? 'w-3/5' : 'w-2/3'}`} />
      </div>
    ))}
  </div>
);

/**
 * A PanelCard to come: its frame and its title (known before the data), then
 * its rows. Folding and editing wait for the real card.
 */
export const PanelCardSkeleton = ({ title, rows = 3 }) => (
  <div className="rounded-xl border border-gray-100">
    <div className="flex h-14 items-center px-4">
      {title ? (
        <span className="truncate font-medium text-gray-900">{title}</span>
      ) : (
        <SkeletonLine className="w-40" />
      )}
    </div>
    <SkeletonRows rows={rows} className="border-t border-gray-100" />
  </div>
);
